import { default as Forgot_45PasswordeNhDYv2trZMeta } from "/app/pages/auth/Forgot-Password.vue?macro=true";
import { default as Loginggfb121eOJMeta } from "/app/pages/auth/Login.vue?macro=true";
import { default as _91id_93hQfwrPffayMeta } from "/app/pages/contacts/company/[id].vue?macro=true";
import { default as index1MT8i63GqmMeta } from "/app/pages/contacts/company/index.vue?macro=true";
import { default as _91id_93EsGAEoOsBxMeta } from "/app/pages/contacts/inventory/[id].vue?macro=true";
import { default as indexK5M2XS7ryuMeta } from "/app/pages/contacts/inventory/index.vue?macro=true";
import { default as formPrMo8yanrZMeta } from "/app/pages/contacts/invoice/form.vue?macro=true";
import { default as indexLt5p9I72kqMeta } from "/app/pages/contacts/invoice/index.vue?macro=true";
import { default as settingbDF6Jh2qSfMeta } from "/app/pages/contacts/invoice/setting.vue?macro=true";
import { default as _91id_93OmVz8Ox4E5Meta } from "/app/pages/contacts/people/[id].vue?macro=true";
import { default as indexpsY6fLY0KwMeta } from "/app/pages/contacts/people/index.vue?macro=true";
import { default as index7k0q4WqxyGMeta } from "/app/pages/contacts/products/index.vue?macro=true";
import { default as indexm698sp1xGSMeta } from "/app/pages/contacts/whatsapp/index.vue?macro=true";
import { default as indexxhVHmrlxy7Meta } from "/app/pages/crm/links/index.vue?macro=true";
import { default as index4CBAUJJccZMeta } from "/app/pages/crm/numbers/index.vue?macro=true";
import { default as indexH9gPJrKcWOMeta } from "/app/pages/crm/settings/index.vue?macro=true";
import { default as indexYRr1FcaGyFMeta } from "/app/pages/evaluation/report/index.vue?macro=true";
import { default as adminb1YVUfrkVgMeta } from "/app/pages/evaluation/save/admin.vue?macro=true";
import { default as editY6cdaPG1eBMeta } from "/app/pages/evaluation/save/edit.vue?macro=true";
import { default as expert265kPtmoYCMeta } from "/app/pages/evaluation/save/expert.vue?macro=true";
import { default as indexDYSRZG9G0VMeta } from "/app/pages/evaluation/save/index.vue?macro=true";
import { default as viewbN0PV6KxJ7Meta } from "/app/pages/evaluation/save/view.vue?macro=true";
import { default as indextV69RDKMxQMeta } from "/app/pages/evaluation/user/index.vue?macro=true";
import { default as index5g6Cknv69wMeta } from "/app/pages/fax/insert/index.vue?macro=true";
import { default as indexvVKNA3Nz2XMeta } from "/app/pages/fax/received/index.vue?macro=true";
import { default as indexwwNcLK2xk6Meta } from "/app/pages/fax/send/index.vue?macro=true";
import { default as indexKck7EkG4z4Meta } from "/app/pages/fax/submitted/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as index18yutfIJgVMeta } from "/app/pages/monitoring/call/index.vue?macro=true";
import { default as index3c5HQGQ6f4Meta } from "/app/pages/monitoring/users/index.vue?macro=true";
import { default as indexxLkcvLX3Z0Meta } from "/app/pages/monitoring/wallboard/index.vue?macro=true";
import { default as indexkU6JjqmuqmMeta } from "/app/pages/notification/index.vue?macro=true";
import { default as indexOY19qoOGj4Meta } from "/app/pages/report/answered/index.vue?macro=true";
import { default as indexHQamHNOZ5qMeta } from "/app/pages/report/calls/index.vue?macro=true";
import { default as indexpYxKnPV0bmMeta } from "/app/pages/report/cdr/index.vue?macro=true";
import { default as indexcPkEbDdRBwMeta } from "/app/pages/report/cost/index.vue?macro=true";
import { default as indexef7m5GbLx8Meta } from "/app/pages/report/fullCdrs/index.vue?macro=true";
import { default as indexfRCL4xrlKtMeta } from "/app/pages/report/hangupReason/index.vue?macro=true";
import { default as index0LxkdOTxA5Meta } from "/app/pages/report/operatorActivity/index.vue?macro=true";
import { default as indexuyooVBgy15Meta } from "/app/pages/report/rating/index.vue?macro=true";
import { default as indexoC8yqaRYn8Meta } from "/app/pages/report/scatteirng/index.vue?macro=true";
import { default as indexTeOk5Kdm9PMeta } from "/app/pages/report/waiting/index.vue?macro=true";
import { default as editJ5FdmNUaBnMeta } from "/app/pages/send/bulk/edit.vue?macro=true";
import { default as indexGhvam7VMhBMeta } from "/app/pages/send/bulk/index.vue?macro=true";
import { default as create4lC482o48HMeta } from "/app/pages/send/groups/create.vue?macro=true";
import { default as editL0gtGoLI1HMeta } from "/app/pages/send/groups/edit.vue?macro=true";
import { default as indexwUR7ZHHKXyMeta } from "/app/pages/send/groups/index.vue?macro=true";
import { default as _91id_93HvKkUzlf93Meta } from "/app/pages/send/report-receive/[id].vue?macro=true";
import { default as indexJf5OWbuqv8Meta } from "/app/pages/send/report-receive/index.vue?macro=true";
import { default as _91id_933e4Rd0xjBPMeta } from "/app/pages/send/report-send/[id].vue?macro=true";
import { default as indexY3LW1UbioyMeta } from "/app/pages/send/report-send/index.vue?macro=true";
import { default as editAT7oCsHq2NMeta } from "/app/pages/send/send-single/edit.vue?macro=true";
import { default as indexlc8gtwoMwAMeta } from "/app/pages/send/send-single/index.vue?macro=true";
import { default as Set_45PasswordFdNH9ZQDPEMeta } from "/app/pages/Set-Password.vue?macro=true";
import { default as indexaQLORJhgHLMeta } from "/app/pages/settings/blackList/index.vue?macro=true";
import { default as indexrBjZYkX3nzMeta } from "/app/pages/settings/destination/index.vue?macro=true";
import { default as index6A41d0FEJCMeta } from "/app/pages/settings/forward/index.vue?macro=true";
import { default as indexZrKHpqgtjNMeta } from "/app/pages/settings/ivr/index.vue?macro=true";
import { default as indexKBmMbyT6xeMeta } from "/app/pages/settings/queue/index.vue?macro=true";
import { default as indexCH3OdfhGGJMeta } from "/app/pages/settings/recording/index.vue?macro=true";
import { default as indexuYlcPWj9deMeta } from "/app/pages/settings/timeCondition/index.vue?macro=true";
import { default as indexq57raA6LEBMeta } from "/app/pages/settings/voiceMail/index.vue?macro=true";
import { default as indexUf183zbL1zMeta } from "/app/pages/support/send/index.vue?macro=true";
import { default as indexQKVLxllSMBMeta } from "/app/pages/support/tickets/index.vue?macro=true";
import { default as indexW9tIWTa9S6Meta } from "/app/pages/users/list/index.vue?macro=true";
import { default as indexPzjsydklFYMeta } from "/app/pages/users/message/index.vue?macro=true";
import { default as indexYxLQrwTLQ9Meta } from "/app/pages/users/operator/index.vue?macro=true";
import { default as indexXIhhzk9fx1Meta } from "/app/pages/users/role/index.vue?macro=true";
import { default as indexntJt0J1UfyMeta } from "/app/pages/users/whatsapp/index.vue?macro=true";
import { default as indexTa4gFkcOr7Meta } from "/app/pages/users/whatsappMessages/index.vue?macro=true";
import { default as indexdXaBcHKxv9Meta } from "/app/pages/videoConference/createLink/index.vue?macro=true";
import { default as indextoWrLjmAxqMeta } from "/app/pages/videoConference/report/index.vue?macro=true";
import { default as index_32copybogRrmJVS2Meta } from "/app/pages/webchat/conversations/index copy.vue?macro=true";
import { default as indexMhI2FuGTQRMeta } from "/app/pages/webchat/conversations/index.vue?macro=true";
import { default as index_32copy5QHsRY3YtxMeta } from "/app/pages/webchat/Customize/index copy.vue?macro=true";
import { default as indexrODFVkz0t8Meta } from "/app/pages/webchat/Customize/index.vue?macro=true";
import { default as reactiveData6vD8QUkGV1Meta } from "/app/pages/webchat/Customize/reactiveData.ts?macro=true";
import { default as index3Q1xYpNdARMeta } from "/app/pages/webchat/dashboard/index.vue?macro=true";
import { default as index8dB2VvWzGhMeta } from "/app/pages/webchat/Department/index.vue?macro=true";
import { default as index6e05rKq5OWMeta } from "/app/pages/webchat/Number/index.vue?macro=true";
import { default as indexA4W0grEPvOMeta } from "/app/pages/webchat/role/index.vue?macro=true";
import { default as indexJjtFKDH14mMeta } from "/app/pages/webchat/Settings/index.vue?macro=true";
import { default as index_32copyCoMtYZn2wnMeta } from "/app/pages/webchat/User/index copy.vue?macro=true";
import { default as indexM86457jrpzMeta } from "/app/pages/webchat/User/index.vue?macro=true";
import { default as component_45stubnO9MU04yTUMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnO9MU04yTU } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "auth-Forgot-Password",
    path: "/auth/Forgot-Password",
    meta: Forgot_45PasswordeNhDYv2trZMeta || {},
    component: () => import("/app/pages/auth/Forgot-Password.vue").then(m => m.default || m)
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: Loginggfb121eOJMeta || {},
    component: () => import("/app/pages/auth/Login.vue").then(m => m.default || m)
  },
  {
    name: "contacts-company-id",
    path: "/contacts/company/:id()",
    component: () => import("/app/pages/contacts/company/[id].vue").then(m => m.default || m)
  },
  {
    name: "contacts-company",
    path: "/contacts/company",
    component: () => import("/app/pages/contacts/company/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts-inventory-id",
    path: "/contacts/inventory/:id()",
    component: () => import("/app/pages/contacts/inventory/[id].vue").then(m => m.default || m)
  },
  {
    name: "contacts-inventory",
    path: "/contacts/inventory",
    component: () => import("/app/pages/contacts/inventory/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts-invoice-form",
    path: "/contacts/invoice/form",
    component: () => import("/app/pages/contacts/invoice/form.vue").then(m => m.default || m)
  },
  {
    name: "contacts-invoice",
    path: "/contacts/invoice",
    component: () => import("/app/pages/contacts/invoice/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts-invoice-setting",
    path: "/contacts/invoice/setting",
    component: () => import("/app/pages/contacts/invoice/setting.vue").then(m => m.default || m)
  },
  {
    name: "contacts-people-id",
    path: "/contacts/people/:id()",
    component: () => import("/app/pages/contacts/people/[id].vue").then(m => m.default || m)
  },
  {
    name: "contacts-people",
    path: "/contacts/people",
    component: () => import("/app/pages/contacts/people/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts-products",
    path: "/contacts/products",
    component: () => import("/app/pages/contacts/products/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts-whatsapp",
    path: "/contacts/whatsapp",
    component: () => import("/app/pages/contacts/whatsapp/index.vue").then(m => m.default || m)
  },
  {
    name: "crm-links",
    path: "/crm/links",
    component: () => import("/app/pages/crm/links/index.vue").then(m => m.default || m)
  },
  {
    name: "crm-numbers",
    path: "/crm/numbers",
    component: () => import("/app/pages/crm/numbers/index.vue").then(m => m.default || m)
  },
  {
    name: "crm-settings",
    path: "/crm/settings",
    component: () => import("/app/pages/crm/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-report",
    path: "/evaluation/report",
    component: () => import("/app/pages/evaluation/report/index.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-save-admin",
    path: "/evaluation/save/admin",
    component: () => import("/app/pages/evaluation/save/admin.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-save-edit",
    path: "/evaluation/save/edit",
    component: () => import("/app/pages/evaluation/save/edit.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-save-expert",
    path: "/evaluation/save/expert",
    component: () => import("/app/pages/evaluation/save/expert.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-save",
    path: "/evaluation/save",
    component: () => import("/app/pages/evaluation/save/index.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-save-view",
    path: "/evaluation/save/view",
    component: () => import("/app/pages/evaluation/save/view.vue").then(m => m.default || m)
  },
  {
    name: "evaluation-user",
    path: "/evaluation/user",
    component: () => import("/app/pages/evaluation/user/index.vue").then(m => m.default || m)
  },
  {
    name: "fax-insert",
    path: "/fax/insert",
    component: () => import("/app/pages/fax/insert/index.vue").then(m => m.default || m)
  },
  {
    name: "fax-received",
    path: "/fax/received",
    component: () => import("/app/pages/fax/received/index.vue").then(m => m.default || m)
  },
  {
    name: "fax-send",
    path: "/fax/send",
    component: () => import("/app/pages/fax/send/index.vue").then(m => m.default || m)
  },
  {
    name: "fax-submitted",
    path: "/fax/submitted",
    component: () => import("/app/pages/fax/submitted/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "monitoring-call",
    path: "/monitoring/call",
    component: () => import("/app/pages/monitoring/call/index.vue").then(m => m.default || m)
  },
  {
    name: "monitoring-users",
    path: "/monitoring/users",
    component: () => import("/app/pages/monitoring/users/index.vue").then(m => m.default || m)
  },
  {
    name: "monitoring-wallboard",
    path: "/monitoring/wallboard",
    component: () => import("/app/pages/monitoring/wallboard/index.vue").then(m => m.default || m)
  },
  {
    name: "notification",
    path: "/notification",
    component: () => import("/app/pages/notification/index.vue").then(m => m.default || m)
  },
  {
    name: "report-answered",
    path: "/report/answered",
    component: () => import("/app/pages/report/answered/index.vue").then(m => m.default || m)
  },
  {
    name: "report-calls",
    path: "/report/calls",
    component: () => import("/app/pages/report/calls/index.vue").then(m => m.default || m)
  },
  {
    name: "report-cdr",
    path: "/report/cdr",
    component: () => import("/app/pages/report/cdr/index.vue").then(m => m.default || m)
  },
  {
    name: "report-cost",
    path: "/report/cost",
    component: () => import("/app/pages/report/cost/index.vue").then(m => m.default || m)
  },
  {
    name: "report-fullCdrs",
    path: "/report/fullCdrs",
    component: () => import("/app/pages/report/fullCdrs/index.vue").then(m => m.default || m)
  },
  {
    name: "report-hangupReason",
    path: "/report/hangupReason",
    component: () => import("/app/pages/report/hangupReason/index.vue").then(m => m.default || m)
  },
  {
    name: "report-operatorActivity",
    path: "/report/operatorActivity",
    component: () => import("/app/pages/report/operatorActivity/index.vue").then(m => m.default || m)
  },
  {
    name: "report-rating",
    path: "/report/rating",
    component: () => import("/app/pages/report/rating/index.vue").then(m => m.default || m)
  },
  {
    name: "report-scatteirng",
    path: "/report/scatteirng",
    component: () => import("/app/pages/report/scatteirng/index.vue").then(m => m.default || m)
  },
  {
    name: "report-waiting",
    path: "/report/waiting",
    component: () => import("/app/pages/report/waiting/index.vue").then(m => m.default || m)
  },
  {
    name: "send-bulk-edit",
    path: "/send/bulk/edit",
    component: () => import("/app/pages/send/bulk/edit.vue").then(m => m.default || m)
  },
  {
    name: "send-bulk",
    path: "/send/bulk",
    component: () => import("/app/pages/send/bulk/index.vue").then(m => m.default || m)
  },
  {
    name: "send-groups-create",
    path: "/send/groups/create",
    component: () => import("/app/pages/send/groups/create.vue").then(m => m.default || m)
  },
  {
    name: "send-groups-edit",
    path: "/send/groups/edit",
    component: () => import("/app/pages/send/groups/edit.vue").then(m => m.default || m)
  },
  {
    name: "send-groups",
    path: "/send/groups",
    component: () => import("/app/pages/send/groups/index.vue").then(m => m.default || m)
  },
  {
    name: "send-report-receive-id",
    path: "/send/report-receive/:id()",
    component: () => import("/app/pages/send/report-receive/[id].vue").then(m => m.default || m)
  },
  {
    name: "send-report-receive",
    path: "/send/report-receive",
    component: () => import("/app/pages/send/report-receive/index.vue").then(m => m.default || m)
  },
  {
    name: "send-report-send-id",
    path: "/send/report-send/:id()",
    component: () => import("/app/pages/send/report-send/[id].vue").then(m => m.default || m)
  },
  {
    name: "send-report-send",
    path: "/send/report-send",
    component: () => import("/app/pages/send/report-send/index.vue").then(m => m.default || m)
  },
  {
    name: "send-send-single-edit",
    path: "/send/send-single/edit",
    component: () => import("/app/pages/send/send-single/edit.vue").then(m => m.default || m)
  },
  {
    name: "send-send-single",
    path: "/send/send-single",
    component: () => import("/app/pages/send/send-single/index.vue").then(m => m.default || m)
  },
  {
    name: "Set-Password",
    path: "/Set-Password",
    meta: Set_45PasswordFdNH9ZQDPEMeta || {},
    component: () => import("/app/pages/Set-Password.vue").then(m => m.default || m)
  },
  {
    name: "settings-blackList",
    path: "/settings/blackList",
    component: () => import("/app/pages/settings/blackList/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-destination",
    path: "/settings/destination",
    component: () => import("/app/pages/settings/destination/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-forward",
    path: "/settings/forward",
    component: () => import("/app/pages/settings/forward/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-ivr",
    path: "/settings/ivr",
    component: () => import("/app/pages/settings/ivr/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-queue",
    path: "/settings/queue",
    component: () => import("/app/pages/settings/queue/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-recording",
    path: "/settings/recording",
    component: () => import("/app/pages/settings/recording/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-timeCondition",
    path: "/settings/timeCondition",
    component: () => import("/app/pages/settings/timeCondition/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-voiceMail",
    path: "/settings/voiceMail",
    component: () => import("/app/pages/settings/voiceMail/index.vue").then(m => m.default || m)
  },
  {
    name: "support-send",
    path: "/support/send",
    component: () => import("/app/pages/support/send/index.vue").then(m => m.default || m)
  },
  {
    name: "support-tickets",
    path: "/support/tickets",
    component: () => import("/app/pages/support/tickets/index.vue").then(m => m.default || m)
  },
  {
    name: "users-list",
    path: "/users/list",
    component: () => import("/app/pages/users/list/index.vue").then(m => m.default || m)
  },
  {
    name: "users-message",
    path: "/users/message",
    component: () => import("/app/pages/users/message/index.vue").then(m => m.default || m)
  },
  {
    name: "users-operator",
    path: "/users/operator",
    component: () => import("/app/pages/users/operator/index.vue").then(m => m.default || m)
  },
  {
    name: "users-role",
    path: "/users/role",
    component: () => import("/app/pages/users/role/index.vue").then(m => m.default || m)
  },
  {
    name: "users-whatsapp",
    path: "/users/whatsapp",
    component: () => import("/app/pages/users/whatsapp/index.vue").then(m => m.default || m)
  },
  {
    name: "users-whatsappMessages",
    path: "/users/whatsappMessages",
    component: () => import("/app/pages/users/whatsappMessages/index.vue").then(m => m.default || m)
  },
  {
    name: "videoConference-createLink",
    path: "/videoConference/createLink",
    component: () => import("/app/pages/videoConference/createLink/index.vue").then(m => m.default || m)
  },
  {
    name: "videoConference-report",
    path: "/videoConference/report",
    component: () => import("/app/pages/videoConference/report/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-conversations-index copy",
    path: "/webchat/conversations/index%20copy",
    component: () => import("/app/pages/webchat/conversations/index copy.vue").then(m => m.default || m)
  },
  {
    name: "webchat-conversations",
    path: "/webchat/conversations",
    component: () => import("/app/pages/webchat/conversations/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-Customize-index copy",
    path: "/webchat/Customize/index%20copy",
    component: () => import("/app/pages/webchat/Customize/index copy.vue").then(m => m.default || m)
  },
  {
    name: "webchat-Customize",
    path: "/webchat/Customize",
    component: () => import("/app/pages/webchat/Customize/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-Customize-reactiveData",
    path: "/webchat/Customize/reactiveData",
    component: () => import("/app/pages/webchat/Customize/reactiveData.ts").then(m => m.default || m)
  },
  {
    name: "webchat-dashboard",
    path: "/webchat/dashboard",
    component: () => import("/app/pages/webchat/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-Department",
    path: "/webchat/Department",
    component: () => import("/app/pages/webchat/Department/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-Number",
    path: "/webchat/Number",
    component: () => import("/app/pages/webchat/Number/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-role",
    path: "/webchat/role",
    component: () => import("/app/pages/webchat/role/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-Settings",
    path: "/webchat/Settings",
    component: () => import("/app/pages/webchat/Settings/index.vue").then(m => m.default || m)
  },
  {
    name: "webchat-User-index copy",
    path: "/webchat/User/index%20copy",
    component: () => import("/app/pages/webchat/User/index copy.vue").then(m => m.default || m)
  },
  {
    name: "webchat-User",
    path: "/webchat/User",
    component: () => import("/app/pages/webchat/User/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/monitoring/dashboard",
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name,
    path: "/login",
    component: component_45stubnO9MU04yTU
  }
]